/* @flow */
// typecheck: ignore file
import Button from 'components/Button.jsx';
import FlexibleBlock from 'components/FlexibleBlock.jsx';
import Glyph from 'components/Glyph.jsx';
import Input from 'components/Input.jsx';
import KeyConstants from 'constants/KeyConstants';
import React, { Component } from 'react';
import shallowCompare from 'react-addons-shallow-compare';

import styles from './styles/ChatSearchBlock.css';

export default class ChatSearchBlock extends Component {
  static propTypes = {
    onDismiss: React.PropTypes.func,
    onQueryChange: React.PropTypes.func.isRequired,
  };

  state = {
    value: '',
  };

  shouldComponentUpdate(nextProps: Object, nextState: Object) {
    return shallowCompare(this, nextProps, nextState);
  }

  handleClose = () => {
    const { onDismiss, onQueryChange } = this.props;

    const value = '';

    this.setState({ value });

    // REVISIT should the caller have the freedom to preserve the last value?
    onQueryChange(value);

    if (onDismiss) {
      onDismiss();
    }
  };

  handleInputBlur = () => {
    const isEmpty = this.state.value.length === 0;

    if (isEmpty) {
      this.handleClose();
    }
  };

  // typecheck: ignore statement
  handleInputChange = (event: SyntheticEvent) => {
    // $FlowFixMe
    const { value } = event.target;

    this.setState({ value });

    this.props.onQueryChange(value);
  };

  // typecheck: ignore statement
  handleInputKeyDown = (event: SyntheticKeyboardEvent) => {
    const { keyCode } = event;
    switch (keyCode) {
      case KeyConstants.ESCAPE:
        this.handleClose();
        break;
      default:
        return;
    }
    event.preventDefault();
  };

  render() {
    const { value } = this.state;
    const { className } = this.props;

    const showClose = value && value.length > 0;
    const placeholder = 'Search for messages or people';

    return (
      <FlexibleBlock
        flex="left"
        className={className}>
        <div className={styles.inputWrapper}>
          <Input
            data-test-selector="chatlist_search_input"
            className={styles.input}
            type="text"
            value={value || ''}
            size="medium"
            placeholder={placeholder}
            onBlur={this.handleInputBlur}
            onChange={this.handleInputChange}
            onKeyDown={this.handleInputKeyDown}
          />
          <Glyph className={styles.inputGlyph} name="search" size="medium" />
        </div>
        {showClose &&
          <Button
            className={styles.closeButton}
            level="icon"
            onClick={this.handleClose}>
            <Glyph
              className={styles.closeGlyph}
              name="close"
              size="small"
              solo
            />
          </Button>
        }
      </FlexibleBlock>
    );
  }
}



// WEBPACK FOOTER //
// ./src/chat/components/ChatSearchBlock.jsx